module.exports = __webpack_public_path__ + "static/media/bay2022FeaturesBanner_Tablet_738x57px_@2x.5d7edda1.jpg";